export default __webpack_public_path__ + "static/Minebest_2021_Introduction-e555711210af9da3b161c11270d457a5.mp4";